import styled from 'styled-components';
import BillingAddress from 'products/nomad_insurance/components/BillingAddress';
import Feedback from 'products/nomad_insurance/components/Feedback';
import StripeCreditCard from 'products/nomad_insurance/components/StripeCreditCard';
import _ErrorMessage from '../ErrorMessage';

export const StyledBillingAddress = styled(BillingAddress)`
  margin-top: 24px;
`;

export const StyledCreditCard = styled(StripeCreditCard)`
  margin-top: 24px;
`;

export const ErrorMessage = styled(_ErrorMessage)`
  margin-top: 24px;
  max-width: 450px;
`;

export const FeedbackText = styled.div``;

export const StyledFeedback = styled(Feedback)`
  margin-top: 16px;
`;
